export default abstract class DataStructureUtils {
  static getArrayPage (list: any[], pageSize: number, page: number): any[] {
    return list.slice(pageSize * (page - 1), pageSize * page)
  }

  static getArrayFraction (list: any[], divisor: number, page: number): any[] {
    const pageSize: number = Math.ceil(list.length / divisor)
    return this.getArrayPage(list, pageSize, page)
  }
}

export const camelize = (str: string) => str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())

const isObject = (obj: any): boolean => Object.prototype.toString.call(obj) === '[object Object]'

const isPropertyEmpty = (obj: any): boolean =>
  Array.isArray(obj)
    ? obj.findIndex(item => !isPropertyEmpty(item)) === -1
    : isObject(obj) && (Object.keys(obj).length === 0 || Object.values(obj).findIndex(value => value !== null) === -1)

export const parseJSONData = (data: string) => {
  const parsedData = JSON.parse(data ?? '{}')

  const camelizeObj = (obj: any) => {
    return Object.keys(obj).reduce((prev, curr) => {
      prev[camelize(curr)] = isObject(obj[curr])
        ? camelizeObj(obj[curr])
        : (
            Array.isArray(obj[curr])
              ? obj[curr].map(item => isObject(item) ? camelizeObj(item) : item)
              : obj[curr]
          )

      return prev
    }, {} as Record<string, any>)
  }

  return camelizeObj(parsedData)
}

export const cleanUpObject = (data: Record<string, any>) => {
  const cleanUp = (obj: any) => {
    return Object.keys(obj).reduce((prev, curr) => {
      if (obj[curr] !== null && !isPropertyEmpty(obj[curr])) {
        prev[curr] = isObject(obj[curr])
          ? obj[curr]
          : (
              Array.isArray(obj[curr])
                ? obj[curr].map(item => isObject(item) ? cleanUp(item) : item)
                : obj[curr]
            )
      }
      return prev
    }, {} as Record<string, any>)
  }

  return cleanUp(data)
}
